/*
import {
  hf,
  ht,
  cr,
  a,
  BoxC,
  TblC,
  TextC,
  LinkC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as LinkC from "./_cccLinkC";
import * as TblC from "./_ccmTblC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';
import * as hf from './_hf';

import * as icm from './icm';
import * as icv from './icv';

export const N = (pz: {
  i11rs: ht.ls,
  bDtl?: ht.b, // 予約詳細画面へ遷移可能、使用状況画面において使用目的・備考を表示
}) => {

  const _tbls = [] as ht.ls;

  pz.i11rs.map((_i11rz: ht.dz, _idxI11r: ht.n) => {

    const _hdrs = [] as ht.ls;

    const _hdrRows = [] as ht.ls;
    _hdrRows.push(
      {
        boxStlz: a(`bc/lt9 bwl/1 bwt/1 ph/1`),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'lblStfz',
            textz: {
              pfx: '　',
            }
          })
        ]
      }
    );
    _i11rz?.cldz?.i111s?.map((_i111z: ht.dz) => {
      _hdrRows.push(
        {
          boxStlz: a(`bc/lt9 bwl/1 bwt/1 fd/rcc ph/1`),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: _i111z._pfx,
              }
            })
          ]
        }
      )
    });
    _hdrs.push({
      boxStlz: a(`dw/f bc/lt9 bwr/1 mt/1 pl/0`),
      cellCs: _hdrRows
    });

    const _bdys = [] as ht.ls;

    _i11rz?.cldz?.i10rs?.map(( _i10rz:ht.dz, _idx: ht.n) => {
      const _bdyRows = [] as ht.ls;
      _bdyRows.push(
        {
/*
          boxStlz: 
            pz.bDtl != false ?
              a('dh/8 fd/ccs p/1 sc/rd1')
            : a('dh/5 fd/ccs p/1 sc/rd2'),
*/
          boxStlz: 
            _idx == 0 ?
              pz.bDtl != false ?
                a('bc/lt9 bwl/1 dh/f fd/ccc p/1')
              : a('bc/lt9 bwl/1 dh/f fd/ccc p/1')
            :
              pz.bDtl != false ?
                a('bc/lt9 bwl/1 bwt/1 dh/f fd/ccc p/1')
              : a('bc/lt9 bwl/1 bwt/1 dh/f fd/ccc p/1'),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: _i10rz._pfx, // 施設名
              }
            })
          ]
        }
      );
      hf.nn(_i10rz.cldz.i111s)?.map((_i111z: ht.dz) => {
        const _i1z1z = _i111z?.cldz?.i1z1s[0];
        const _i1zrz = _i1z1z?.cldz?.i1zrs[0];
        const _i18rz = _i1zrz?.cldz?.i18rs[0];
        //hf.l(`icvI1z___TzUse 108: ${hf.s(_i18rz)}`);

        if (hf.f(_i1zrz) && hf.f(_i18rz)) {
          _bdyRows.push(
            {
//              boxStlz: a('dh/f fd/css p/1'),
              boxStlz: 
                _idx == 0 ?
                  a('bc/lt9 bwl/1 dh/f fd/css p/1')
                : a('bc/lt9 bwl/1 bwt/1 dh/f fd/css p/1'),
              oClds: [
                cr.c(TextC.N, { // 団体番号
                  key: -15,
                  textz: {
                    pfx: _i18rz?.i18rab100s,
                    stlz: a('ts/s'),
                    ptyz: a('tn/1'),
                  }
                }),
                cr.c(LinkC.N, { // 団体名
                  key: -10,
                  boxStlz: a(`dw/f`),
                  cz: {
                    onPrs:
                    icm.chkPmn('11011') && pz.bDtl != false ? // 予約を利用可能な場合
                    () => {
                      cr.moveTo({
                        pageName: 'icvI1zS10RzR',
                        pmrz: {
                          f: hf.cvtNbr('e', _i1zrz._fst, icv.srtz.nbrz3),
                        }
                      })
                    }
                    : undefined,
                  },
                  linkCz: {
                    boxStlz: a(`dw/f fd/rss`), // add
                    textz: {
                      pfx: (_i1zrz?.i1zrs1100i == 80 ? '■' : '' ) + _i18rz?._pfx,
                      stlz: 
                        cr.chkDvc() == 'p' ?
                          icm.chkPmn('11011') && pz.bDtl != false ?
                            a('tb tc/rd5 tu ts/m')
                          : a('ts/m')
                        : a('ts/s'),
                      ptyz:
                        cr.chkDvc() == 'p' ?
                          a('tn/3')
                        : a('tn/3')
                    }
                  },
                  pslStlz: a('dw/f')
                }),
                pz.bDtl != false ?
                cr.c(TextC.N, {
                  key: -20,
                  textz: {
                    pfx: _i1zrz?.i1zra4100s, // 目的
                    stlz: a('ts/s'),
                    ptyz: a('tn/1'),
                  }
                })
                : undefined,
                pz.bDtl != false ?
                cr.c(TextC.N, {
                  key: -30,
                  textz: {
                    pfx: _i1zrz?._ctn ?? ' ', // 備考
                    stlz: a('ts/s'),
                    ptyz: a('tn/1'),
                  }
                })
                : undefined,
              ]
            },
          )
        }
        else {
          _bdyRows.push(
            {
              boxStlz:
                _idx == 0 ? 
                  a('bc/lt9 bwl/1 fd/ccs p/1')
                : a('bc/lt9 bwl/1 bwt/1 fd/ccs p/1'),
              oClds: [
              ]
            },
          )
        }
      })
      _bdys.push({
//        boxStlz: a(`fd/rss`),
//        boxStlz: a(`dh/12 dw/f f/n fd/rss`),
        boxStlz: a(`bc/lt9 bwr/1 dh/12 dw/f f/n fd/rss mb/0 pl/0`),
        cellCs: _bdyRows
      });
    });

    if (_bdys.length >= 1) {
      _tbls.push(
        cr.c(TblC.N, {
          key: _idxI11r,
          boxCz: {
//            boxStlz: a(`dw/f mb/5`),
            boxStlz: a(`dw/f`),
          },
          hdrCz: {
            abtType: 'hdrStfz',
            boxStlz: a(`mb/0`),
            lineCs: _hdrs
          },
          bdyCz: {
            abtType: 'lineStfz',
            lineCs: _bdys
          }
        })
      )
    } 

  })

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'cttCmnz',
      boxStlz: a(`dw/f`),
      oClds: _tbls,
    })
  )

};
